module.exports = __webpack_public_path__ + "img/img_value.03b35456.png";